<template>
  <div
    v-if="request && request.artwork && request.artwork.downloadUrl"
    ref="backdrop"
    class="core-media-modal-backdrop"
    role="dialog"
    aria-modal="true"
    aria-label="Artwork preview"
    tabindex="-1"
    @click.self="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <div class="core-media-modal">
      <img
        :src="request.artwork.downloadUrl"
        :alt="request.title ? `${request.title} artwork` : 'Artwork preview'"
        class="core-media-modal-image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ArtworkPreviewModal",

  props: {
    request: {
      type: Object,
      default: null,
    },
  },

  emits: ["close"],

  watch: {
    request(value) {
      if (!value) return;

      this.$nextTick(() => {
        this.$refs.backdrop?.focus();
      });
    },
  },
};
</script>
